import { messages as de } from "./de/messages";
import { messages as en } from "./en/messages";
import { messages as es } from "./es/messages";
import { messages as et } from "./et/messages";
import { messages as fr } from "./fr/messages";
import { messages as hu } from "./hu/messages";
import { messages as lt } from "./lt/messages";
import { messages as lv } from "./lv/messages";
import { messages as pl } from "./pl/messages";
import { messages as pt } from "./pt/messages";
import { messages as ru } from "./ru/messages";
import { messages as sk } from "./sk/messages";
import { messages as sr } from "./sr/messages";
import { messages as sv } from "./sv/messages";
import { messages as tr } from "./tr/messages";

export const messages = {
  en,
  de,
  es,
  et,
  hu,
  lt,
  lv,
  pl,
  ru,
  sk,
  sr,
  sv,
  tr,
  fr,
  pt,
};
